import {DragEvent, useCallback, useState} from 'react';

export const useOnDragOver = (
    onDrop: (file: File[]) => void,
    options?: {
        disabled?: boolean;
    },
) => {
    const disabled = options?.disabled || false;
    const [isDraggedOver, setIsDraggedOver] = useState(false);
    const handleDragOver = useCallback(
        (event: DragEvent<HTMLInputElement>) => {
            if (!disabled) {
                event.preventDefault();
                setIsDraggedOver(true);
            }
        },
        [disabled],
    );
    const handleDragLeave = useCallback(() => {
        setIsDraggedOver(false);
    }, []);
    const handleOnDrop = useCallback(
        (event: DragEvent<HTMLInputElement>) => {
            if (!disabled) {
                event.preventDefault();
                onDrop(Array.from(event.dataTransfer.files));
                setIsDraggedOver(false);
            }
        },
        [disabled],
    );
    return {
        isDraggedOver,
        onDragLeave: handleDragLeave,
        onDragOver: handleDragOver,
        onDrop: handleOnDrop,
    };
};
